<template>
    <div
        v-if="index > 0"
        class="h-2 surface-secondary"
    />
    <LearningMoment
        :config="item.component"
    />
</template>

<script setup>
    const props = defineProps({
        index: Number,
        item: Object,
        isLast: Boolean,
    })
</script>
